import Routes from '../../routes/routes'
import { buildPostApi } from '../helpers'

const mapPayload = ({
    idPersona,
    paso,
    precio,
    subOrigen,
    origen,
    canal,
    ramo,
    fechaInteraccion,
    documento,
    apellidos,
    nombre,
    idSolicitud,
    idLeadMM,
    tipo,
    idCorrelacion,
    idProveedor,
    varFormulario,
    canalComunicacion,
}) => ({
    idPersona,
    paso,
    precio,
    subOrigen,
    origen,
    canal,
    ramo,
    fechaInteraccion,
    documento,
    apellidos,
    nombre,
    idSolicitud,
    idLeadMM,
    tipo,
    verificacion: idCorrelacion && idProveedor
        ? { idCorrelacion, idProveedor }
        : null,
    varFormulario: varFormulario.map(({ tipoX, valorX, varX }) => ({ tipoX, valorX, varX })),
    canalComunicacion: canalComunicacion.map(({ tipo, valor }) => ({ tipo, valor })),
})

export default buildPostApi({
    route: Routes.apiCarRentalClickToCall,
    mapParams: () => {},
    mapPayload,
})
